import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { MunicipalityFilterRequest } from "@/main/models/request";

export abstract class IMunicipalityApi {
	abstract getDomain(request: MunicipalityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getDomainPublic(request: MunicipalityFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
